import React from 'react'

import { Box, Button, Text } from '@factorialco/deprecated-design-system'
import { F0TagAlert } from '@factorialco/f0-react'
import { Spinner } from '@factorialco/f0-react/dist/experimental'
import {
  TrainingsCategoryMapConfigCategoryEnum,
  TrainingsCategoryMapConfigDocument,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { CategoryConfigItemMapping } from './CategoryConfigItemMapping'
import { useFundaeConfigMapped } from './useFundaeConfigMapped'

export const FundaeSubsidySection = () => {
  const { loading, data } = useQuery(TrainingsCategoryMapConfigDocument)
  const [modalOpen, setModalOpen] = React.useState<boolean>(false)
  const [selectedCategory, setSelectedCategory] = React.useState<
    TrainingsCategoryMapConfigCategoryEnum | undefined
  >()

  const { educationLevelMapped, professionalCategoryMapped } = useFundaeConfigMapped({
    categoryMapConfigs: data?.trainings.categoryMapConfigs ?? [],
    educationLevels: data?.contracts.spanishEducationLevels ?? [],
    professionalCategories: data?.contracts.spanishProfessionalCategories ?? [],
  })

  if (loading) return <Spinner />

  return (
    <Box width="full" alignItems="flexEnd">
      <Box gap="s8" width="full">
        <Text size="300" weight="semibold" color="grey1000">
          {i18n.t('trainings.training_settings.fundae_subsidization.box.title')}
        </Text>
        <Box>
          <Box
            paddingY="s16"
            paddingX="s24"
            border={{
              all: {
                color: 'grey400',
                width: 's1',
                style: 'solid',
              },
            }}
            borderRadius={{ topLeft: 'abs008', topRight: 'abs008' }}
          >
            <Box justifyContent="spaceBetween" flexDirection="row">
              <Box alignItems="flexStart" gap="s4">
                <Text size="200" weight="semibold" color="grey1000">
                  {i18n.t(
                    'trainings.training_settings.fundae_subsidization.box.professional_category_title'
                  )}
                </Text>
                <Text size="100" weight="normal">
                  {i18n.t(
                    'trainings.training_settings.fundae_subsidization.box.default_description'
                  )}
                </Text>
                {!professionalCategoryMapped && (
                  <F0TagAlert
                    text={i18n.t('trainings.training_settings.fundae_subsidization.box.alert_tag')}
                    level="critical"
                  />
                )}
              </Box>
              <Button
                onClick={() => {
                  track(
                    trackingEvents.training.trainingDetail.fundae.finishGroupsExport
                      .settingsProfessionalCategory
                  )
                  setModalOpen(true)
                  setSelectedCategory('professionalcategory')
                }}
                type="secondary"
                iconName="arrow-right"
              />
            </Box>
          </Box>
          <Box
            paddingY="s16"
            paddingX="s24"
            border={{
              bottom: {
                color: 'grey400',
                width: 's1',
                style: 'solid',
              },
              left: {
                color: 'grey400',
                width: 's1',
                style: 'solid',
              },
              right: {
                color: 'grey400',
                width: 's1',
                style: 'solid',
              },
            }}
            borderRadius={{ bottomLeft: 'abs008', bottomRight: 'abs008' }}
          >
            <Box justifyContent="spaceBetween" flexDirection="row">
              <Box alignItems="flexStart" gap="s4">
                <Text size="200" weight="semibold" color="grey1000">
                  {i18n.t(
                    'trainings.training_settings.fundae_subsidization.box.education_level_title'
                  )}
                </Text>
                <Text size="100" weight="normal">
                  {i18n.t(
                    'trainings.training_settings.fundae_subsidization.box.default_description'
                  )}
                </Text>
                {!educationLevelMapped && (
                  <F0TagAlert
                    text={i18n.t('trainings.training_settings.fundae_subsidization.box.alert_tag')}
                    level="critical"
                  />
                )}
              </Box>
              <Button
                onClick={() => {
                  track(
                    trackingEvents.training.trainingDetail.fundae.finishGroupsExport
                      .settingsEducationalLevel
                  )
                  setModalOpen(true)
                  setSelectedCategory('educationlevel')
                }}
                type="secondary"
                iconName="arrow-right"
              />
            </Box>
          </Box>
        </Box>
      </Box>
      {modalOpen && (
        <CategoryConfigItemMapping
          categoryMapConfigs={data?.trainings.categoryMapConfigs ?? []}
          fields={
            selectedCategory === 'professionalcategory'
              ? (data?.contracts.spanishProfessionalCategories ?? [])
              : (data?.contracts.spanishEducationLevels ?? [])
          }
          category={selectedCategory}
          closeModal={setModalOpen}
        />
      )}
    </Box>
  )
}
